export const loadScript = (src: string): void => {
    const script = document.createElement('script');
    script.setAttribute('nonce', '328fae43900d');
    script.setAttribute('src', src);
    document.head.appendChild(script);
}
